(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[89],{

/***/ 1532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18598);
/* harmony import */ var components_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50677);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _templateObject, _templateObject2, _templateObject3;






var Hero = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  background: ", ";\n  color: ", ";\n  padding: 40px 10px;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.GREEN;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.WHITE;
});
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  max-width: ", ";\n  margin: auto;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.width.medium;
});
var Title = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(components_typography__WEBPACK_IMPORTED_MODULE_2__.H1)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  color: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.BEIGE;
});

var PageHero = function PageHero(_ref5) {
  var title = _ref5.title,
      text = _ref5.text;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Hero, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Content, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
        children: text
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageHero);

/***/ }),

/***/ 89003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hallbarhet; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(18598);
;// CONCATENATED MODULE: ./src/assets/images/fn-12.png
/* harmony default export */ var fn_12 = ({"src":"/_next/static/media/fn-12.19845508.png","height":700,"width":700,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEW/iyvPp2C8hyTVs3TElT7LoFPdwo/YuH0++FL6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nBXJtxHAMBAEsT337L9jjZCCrhsGne6k0u3eqWBJAZy8RMZP9xRDs6X8aRs+HI4At9VXKAIAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/fn-15.png
/* harmony default export */ var fn_15 = ({"src":"/_next/static/media/fn-15.8a479b4b.png","height":1024,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJ1BMVEUepTguq0V/y405sE9Cs1cWojBVu2hKt14jpzxrxHuU1J/K6tD2/Pi5j/qwAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAANklEQVR4nBXItw0AMAzEwA8KTvvPa6jigXAzHEzUKW1tg8GIbgOpQyYA3FeeZokcLElaI3LOByLvAM4igtD5AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/components/PageHero.js
var PageHero = __webpack_require__(1532);
// EXTERNAL MODULE: ./src/components/typography/index.js + 5 modules
var typography = __webpack_require__(50677);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/hallbarhet.js


var _templateObject, _templateObject2, _templateObject3;










var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  min-height: calc(100vh - 400px);\n\n  @media (max-width: ", ") {\n    flex-direction: column;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakPoints.mobile;
});
var Section = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: ", ";\n  color: ", ";\n  text-align: center;\n  padding: 70px 25px;\n"])), function (_ref2) {
  var background = _ref2.background;
  return background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.GREEN;
});
var ImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 25px 10px;\n"])));

var Hallbarhet = function Hallbarhet() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      height: '100%'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHero/* default */.Z, {
      title: "H\xE5llbarhet",
      text: "Med Digito vid er sida skapar vi en mer h\xE5llbara verksamhet"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography.H2, {
          children: "M\xE5l 12: H\xE5llbar konsumtion och produktion."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: fn_12,
            alt: "fn12",
            layout: "fixed",
            width: 200,
            height: 200,
            placeholder: "blur"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(typography.H3, {
          children: ["Omst\xE4llning till en h\xE5llbar konsumtion och produktion av varor \xE4r en n\xF6dv\xE4ndighet f\xF6r att minska v\xE5r negativa p\xE5verkan p\xE5 klimat och milj\xF6.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "D\xE4rf\xF6r lyder v\xE5rt motto \u2013 Vi \xE4r inte i m\xE5l f\xF6rr\xE4n visitkorten \xE4r i mobilen ist\xE4llet f\xF6r papperskorgen."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        background: "#e9d3b8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography.H2, {
          children: "M\xE5l 15: Ekosystem och biologisk m\xE5ngfald."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ImgWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: fn_15,
            alt: "fn15",
            layout: "fixed",
            width: 200,
            height: 200,
            placeholder: "blur"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography.H3, {
          children: "H\xE5llbara ekosystem och biologisk m\xE5ngfald \xE4r grunden f\xF6r v\xE5rt liv p\xE5 jorden. D\xE4rf\xF6r har vi valt att plantera nya tr\xE4d runtom i v\xE4rlden."
        })]
      })]
    })]
  });
};

Hallbarhet.layoutOptions = {
  fullHeight: true,
  footer: true,
  noBottomSpacing: true
};
/* harmony default export */ var hallbarhet = (Hallbarhet);

/***/ }),

/***/ 15050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hallbarhet",
      function () {
        return __webpack_require__(89003);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,774,888,179], function() { return __webpack_exec__(15050); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);